import { render, staticRenderFns } from "./DashboardRedirectContainer.vue?vue&type=template&id=a413d074&scoped=true&"
import script from "./DashboardRedirectContainer.vue?vue&type=script&lang=js&"
export * from "./DashboardRedirectContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a413d074",
  null
  
)

export default component.exports